"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variantBgColor = exports.variantTextColor = exports.themeBgColor = exports.themeTextColor = exports.themeVariant = exports.VARIANTS = void 0;
exports.VARIANTS = [
    "primary",
    "secondary",
    "tertiary",
    "quaternary",
    "disabled",
    "success",
    "warning",
    "error",
];
function themeVariant(values) {
    return function (props) {
        const { variant = "default", theme } = props;
        return values[variant]({ theme });
    };
}
exports.themeVariant = themeVariant;
function themeTextColor(theme, variant) {
    return theme.variantColors[variant].text;
}
exports.themeTextColor = themeTextColor;
function themeBgColor(theme, variant) {
    const { bg } = theme.variantColors[variant];
    return theme[bg];
}
exports.themeBgColor = themeBgColor;
exports.variantTextColor = themeVariant(Object.assign({ default: ({ theme }) => theme.textColor }, exports.VARIANTS.reduce((prev, variant) => {
    return Object.assign(Object.assign({}, prev), { [variant]: ({ theme }) => themeTextColor(theme, variant) });
}, {})));
exports.variantBgColor = themeVariant(Object.assign({ default: ({ theme }) => theme.bgColor }, exports.VARIANTS.reduce((prev, variant) => {
    return Object.assign(Object.assign({}, prev), { [variant]: ({ theme }) => themeBgColor(theme, variant) });
}, {})));
//# sourceMappingURL=variants.js.map